import { homApi } from './hom'

interface TUserMeta {
  petName?: string
  userLevel?: string
  userTitle?: string
  lastMathVaultChest?: string
  dragonHatchDate?: number
}
const userMetaApi = homApi.injectEndpoints({
  endpoints: (builder) => ({
    updateUserMeta: builder.mutation<{ success: true }, TUserMeta>({
      query: (body) => ({
        url: '/v1/user-meta',
        method: 'POST',
        body,
      }),
    }),
  }),
})

export const { updateUserMeta } = userMetaApi.endpoints
export const { useUpdateUserMetaMutation } = userMetaApi
